module.exports = __webpack_public_path__ + "img/fourday_ps_08.d2ef2c90.jpg";